import React, { useEffect, useState } from "react";
import VerticalBarChart from "../../../components/Charts/VerticalBarChart";
import { Loader } from "rsuite";
import { axInstBasic } from "../../../components/Service/Service";

// const LobWiseApi = async (Arn) => {
//   const basicAuth =
//     "Basic " +
//     btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
//   try {
//     const res = await axInst.post(
//       `${process.env.REACT_APP_API_URL}lobWiseJC`,
//       { isSearchArn: Arn },
//       { headers: { Authorization: basicAuth } }
//     );
//     return res.data.result;
//   } catch (error) {
//     console.error(
//       "API Error:",
//       error.response ? error.response.data : error.message
//     );
//     throw error;
//   }
// };

export const LobWiseApi = async (isSearchArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}lobWiseJC`,{isSearchArn}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default function LobWise({
  isSearchArn,
  isArn,
  setIsSearchArn,
  isWaterMark,
}) {
  const [vertidata, setVertidata] = useState(null);
  const [isWaterMarkData, setIsWaterMarkData] = useState(null);

  useEffect(() => {
    if (isSearchArn && isArn) {
      LobWiseApi(isArn)
        .then((data) => {
          setVertidata(data); // Store fetched data
        })
        .catch((error) => {
          console.error("Error fetching total open JC:", error);
        });
    }
    setIsSearchArn(false);
  }, [isSearchArn, isArn, setIsSearchArn]);

  useEffect(() => {
    setIsWaterMarkData();
  }, []);

  // If vertidata is null or undefined, prevent rendering the chart
  if (!vertidata) {
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  }

  // Extract key and doc_count data for chart
  const keyData = vertidata?.buckets?.map((bucket) => bucket.key) || [];
  const valData = vertidata?.buckets?.map((bucket) => bucket.doc_count) || [];

  return (
    <div className="p-2 relative">
      {isWaterMarkData && (
        <div className="absolute inset-0 flex items-center justify-center opacity-25 text-1xl text-center z-50">
          <div>
            <div>{isWaterMarkData.userId}</div>
            <div>{isWaterMarkData.date}</div>
            <div>{isWaterMarkData.ip}</div>
          </div>
        </div>
      )}
      <VerticalBarChart data={{ keyData, valData }} top="10%" height="200px" />
    </div>
  );
}
